import { Swiper, Autoplay, EffectFade } from 'swiper'

Swiper.use([Autoplay, EffectFade])

const $slider = document.querySelector('.dyk-slider')

const fn = {
  init: () => {
    if ($slider.querySelectorAll('.swiper-slide').length < 2) {
      return
    }

    new Swiper($slider.querySelector('.swiper-container'), {
      autoHeight: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
      },
      allowTouchMove: false,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    })
  },
}

export default {
  can: () => $slider,
  run: fn.init,
}
